// extracted by mini-css-extract-plugin
export var content = "ConferenceGenericSection-module--content--9f5ed";
export var image = "ConferenceGenericSection-module--image--ba099";
export var listContent = "ConferenceGenericSection-module--listContent--d2840";
export var listItem = "ConferenceGenericSection-module--listItem--56ce5";
export var wrapper = "ConferenceGenericSection-module--wrapper--4552d";